var e = /* @__PURE__ */ ((_) => (_.CLICK_TO_COPY = "click_to_copy", _.SEE_REVEALED_DEAL = "see_revealed_deal", _.ACTIVATE_DEAL = "activate_deal", _.MASKED_CLICK = "masked_click", _))(e || {});
export {
  e as CouponCardAction
};
